import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PregledReversService {
  constructor(private _http: HttpClient) {}

  dohvatiReverse(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_reverse', a)
      .pipe(map((res: any) => res));
  }

  dohvatiJednuIzdatnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_jednu_izdatnicu', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkePopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkePopis', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeDodaj(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeDodaj', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeUredi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeUredi', a)
      .pipe(map((res: any) => res));
  }

  zavrsiRevers(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'zavrsi_revers', a)
      .pipe(map((res: any) => res));
  }

  obrisiRevers(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'obrisi_revers', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeObrisi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeObrisi', a)
      .pipe(map((res: any) => res));
  }

  artiklPopisZaPoslovnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'artiklPopisZaPoslovnicu', a)
      .pipe(map((res: any) => res));
  }

  stornirajRevers(a: any) {
    return this._http.post(AppConfig.ipAddress + 'storno_revers', a)
      .pipe(map((res: any) => res));
  }

  poslovnicaPopis(a: any) {
    return this._http.post(AppConfig.ipAddress + 'poslovnicaPopis', a)
      .pipe(map((res: any) => res));
  }

  dodajRevers(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dodaj_revers', a)
      .pipe(map((res: any) => res));
  }

  urediRevers(a: any) {
    return this._http.post(AppConfig.ipAddress + 'uredi_revers', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPartnere(a:any){
    return this._http.post(AppConfig.ipAddress + 'partner_popisV2', a)
      .pipe(map((res: any) => res ));
  }
}